/**
 * @module root/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
export const APP_ROUTE_CONSTANTS = {
  MY_PROFILE_ROUTE: '/my-profile',
  AUTOPAY_URL: '/autopay',
  CUSTOMER_ACTIVITY_LOG_URL: '/customer-activity-log',
  BILLING_LANDING_URL: '/billing-landing',
  SUPPORT_LANDING_URL: '/support-landing',
  SUPPORT_LEGACY_URL: 'https://support.t-mobile.com/welcome',
  REFILL_YOUR_ACCOUNT_URL: '/refill-account',
  CART_PAYMENT: '/cart/payment',
  CART_SHIPPING: '/cart/shipping',
  ORDER_SUMMARY_URL: '/order-summary',
  SEGMENTATION_URL: '/my-profile/segmentation',
  CPS_URL: '/change-plans-services/rate-plans',
  LINE_LANDING_URL: '/line-landing',
  ACCOUNT_LANDING_PATH: '/account-landing',
  ORDER_REVIEW: '/cart/order-review',
  EBB_URL: '/ebb',
  OTP_URL: '/one-time-payment',
};
